import { Platform, Share } from 'react-native';
import type * as ExpoClipboard from 'expo-clipboard';
import { moduleNatifPresent } from './modulesNatifs';

/**
 * COPIE DANS LE PRESSE-PAPIERS, AVEC REPLI SUR LA FEUILLE DE PARTAGE.
 *
 * `expo-clipboard` se charge à la demande (`moduleNatifPresent`) : un binaire qui ne contient pas le
 * module — build de développement, mise à jour à distance sur un binaire plus ancien — ne doit pas
 * planter au démarrage (cf. `modulesNatifs`, plantage ExpoAsset du 10/10/2026). Il retombe sur la
 * feuille de partage, qui propose « Copier » elle aussi.
 *
 * Trois issues, et seule la première autorise l'état « Copié » : on ne dit pas « Copié » quand la
 * personne vient d'ouvrir une feuille de partage qu'elle peut encore refermer.
 *   - 'copie'   : le texte est dans le presse-papiers ;
 *   - 'partage' : la feuille de partage a pris le relais ;
 *   - 'echec'   : ni l'un ni l'autre, l'écran le dit.
 */
export type ResultatCopie = 'copie' | 'partage' | 'echec';

function expoClipboard(): typeof ExpoClipboard | null {
  // Le web a sa propre implémentation (navigator.clipboard), sans module natif.
  if (Platform.OS !== 'web' && !moduleNatifPresent('ExpoClipboard')) return null;
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  return require('expo-clipboard') as typeof ExpoClipboard;
}

export async function copierTexte(texte: string): Promise<ResultatCopie> {
  if (!texte.trim()) return 'echec';
  try {
    const presse = expoClipboard();
    // `setStringAsync` rend `false` quand le navigateur refuse (permission, contexte non sécurisé).
    if (presse && (await presse.setStringAsync(texte))) return 'copie';
  } catch {
    // Retombe sur le partage ci-dessous.
  }
  try {
    await Share.share({ message: texte });
    return 'partage';
  } catch {
    return 'echec';
  }
}
